import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AUTH_COLORS, authFieldSx, authLabelSx, authPasswordFieldSx } from './authDialogStyles';

const AuthTextField = ({
    label,
    type,
    InputProps,
    ...props
}) => {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === 'password';

    const passwordAdornment = isPassword ? (
        <InputAdornment position='end'>
            <IconButton
                type='button'
                onClick={() => setShowPassword((value) => !value)}
                onMouseDown={(event) => event.preventDefault()}
                tabIndex={-1}
                aria-label={showPassword ? t('Скрыть пароль') : t('Показать пароль')}
                sx={{
                    p: '4px',
                    color: 'inherit',
                    '&:hover': { color: 'inherit', backgroundColor: 'transparent' },
                    '&:focus-visible': {
                        outline: `2px solid ${AUTH_COLORS.primary}`,
                        outlineOffset: 1,
                    },
                }}
            >
                {showPassword
                    ? <VisibilityOffOutlinedIcon sx={{ fontSize: 20 }} />
                    : <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />}
            </IconButton>
        </InputAdornment>
    ) : InputProps?.endAdornment;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', alignSelf: 'stretch' }}>
            {label && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box component='span' sx={authLabelSx}>{label}</Box>
                </Box>
            )}
            <TextField
                fullWidth
                variant='outlined'
                sx={isPassword ? [authFieldSx, authPasswordFieldSx] : authFieldSx}
                type={isPassword && showPassword ? 'text' : type}
                InputProps={{
                    ...InputProps,
                    endAdornment: passwordAdornment,
                }}
                {...props}
            />
        </Box>
    );
};

export default AuthTextField;
